export default __webpack_public_path__ + "static/media/neon-dark-icon.93d6a76b.svg";